import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierSegmentationUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SegmentationScore} from "~/pages/supplier-360/types/Supplier360Types";

/** Segmentation score for one entity (`GET supplier_360/segmentation/?entity={id}`). One-to-one — returns the single result or null. */
export function useSupplierSegmentationQuery(entityId: number | undefined) {
    const url = supplierSegmentationUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => {
            const resp = (await queryHttp.get<PageResponse<SegmentationScore>>(url)).data;
            return resp.results[0] ?? null;
        },
        enabled: Boolean(entityId),
    });
}
